"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'currency.error.missingCurrencyCode': '需要货币代码',
    'currency.error.failedToGetRate': '获取汇率失败',
    'currency.error.missingConversionParams': '需要源货币、目标货币和金额',
    'currency.error.invalidAmount': '金额必须是正数',
    'currency.error.failedToConvert': '货币转换失败',
    'currency.error.failedToGetCurrencies': '获取货币列表失败',
    'currency.error.failedToGetSupportedCurrencies': '获取支持的货币失败',
    'currency.error.missingHistoricalParams': '需要货币代码、开始日期和结束日期',
    'currency.error.invalidDateFormat': '日期格式必须为 YYYY-MM-DD',
    'currency.error.failedToGetHistoricalRates': '获取历史汇率失败',
    'currency.error.failedToGetGoldPrice': '获取黄金价格失败',
};
